import { useCallback, useEffect, useRef } from 'react';

export const useDelayedCallback = <Callback extends (...args: any[]) => any>(
  callback: Callback,
  delay = 500,
): [execute: (...args: Parameters<Callback>) => void, kill: () => void] => {
  const timeoutRef = useRef<number>();

  const execute = useCallback(
    (...args: Parameters<Callback>) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = window.setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay],
  );

  const kill = useCallback(() => {
    timeoutRef.current && window.clearTimeout(timeoutRef.current);
    timeoutRef.current = undefined;
  }, []);

  useEffect(
    () => () => {
      timeoutRef.current && window.clearTimeout(timeoutRef.current);
      timeoutRef.current = undefined;
    },
    [callback, delay],
  );

  return [execute, kill];
};
